import React from 'react';
import { CloseableModal } from '../../../../../../../components/CloseableModal';
import { ModalBody } from './ModalBody';
import { useForm } from 'react-hook-form';
import { SelectOption } from '../../../../../../../components/Select';
import { loadDepartmentOptions } from '..';
import { AlertType } from '../../../../../../../components/Alert';

interface PropTypes {
  isModalOpen: boolean;
  setSelectedDepartment: (selectedOption: SelectOption) => void;
  setIsModalOpen: (isOpen: boolean) => void;
  setIsLoading: (isLoading: boolean) => void;
  setDepartmentOptions: (selectOptions: SelectOption[]) => void;
  setIsAlertVisible: (isAlertVisible: boolean) => void;
  setAlertType: (alertType: AlertType) => void;
  setAlertMessage: (message: JSX.Element) => void;
}

export interface DepartmentValue {
  departmentName: string;
}

export function CreateDepartmentModal(props: PropTypes) {
  const { register, handleSubmit, formState, reset, getValues } =
    useForm<DepartmentValue>({
      mode: 'onChange',
      defaultValues: {
        departmentName: null,
      },
    });

  const handleClose = () => {
    props.setIsModalOpen(false);
    props.setIsAlertVisible(true);
    reset();

    loadDepartmentOptions()
      .then(props.setDepartmentOptions)
      .finally(() => props.setIsLoading(false));
  };

  return (
    <CloseableModal
      className='modal-dialog-centered'
      onClose={handleClose}
      isOpen={props.isModalOpen}
      size='md'
      closeDisabled={false}
      keyboard={true}
      backdrop={true}
      headerTitle={'Create Department'}
      bodyChildren={
        <ModalBody
          handleSubmit={handleSubmit}
          register={register}
          isValid={formState.isValid}
          handleClose={handleClose}
          setSelectedDepartment={props.setSelectedDepartment}
          getValues={getValues}
          setAlertType={props.setAlertType}
          setAlertMessage={props.setAlertMessage}
        />
      }
    />
  );
}
